import React from 'react';

/**
 * Generalized tour progress dots, extracted from ForecastTourProgressDots.
 * Styling inherits from the existing `forecast-tour-*` classes (see index.css)
 * via the `atlas-tour-*` aliases in atlas-tour.css.
 */
export const TourProgressDots: React.FC<{
  currentIndex: number;
  total: number;
}> = ({ currentIndex, total }) => {
  const dots = Array.from({ length: total }, (_, i) => i);
  return (
    <div
      className="atlas-tour-progress-dots forecast-tour-progress-dots"
      role="presentation"
      aria-hidden
    >
      {dots.map((i) => {
        const state = i < currentIndex ? 'done' : i === currentIndex ? 'current' : 'upcoming';
        return (
          <span
            key={i}
            className={`atlas-tour-dot forecast-tour-dot atlas-tour-dot--${state} forecast-tour-dot--${state}`}
          />
        );
      })}
    </div>
  );
};
